import { useContext } from "react";
import permissionContext from "../providers/Permissions/PermissionContext";

function usePermission() {
    return useContext(permissionContext);
}

export default usePermission;
